export default "__VITE_ASSET__DX2_dCK1__"